import { createAsyncThunk, rejectWithValue } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { showApiErrorToast, showApiSuccessToast } from "../../utils/toastErrorHandler";
import { updateLeaveApprovalApi, fetchLeaveEntryApi, getManualEntryApi, updateManualApprovalApi } from "./ApprovalApi";

const handleError = (err, rejectWithValue) => {
  if (err.response?.status === 401) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  }
  const errorMessage = err.response?.data?.message ||
    err.response?.data.error ||
    err.message || "Something went wrong"

  showApiErrorToast(errorMessage)
  return rejectWithValue(err.response?.data || { message: err.message })
}


export const fetchLeaveList = createAsyncThunk(
  "LeaveEntry/leave_list",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await fetchLeaveEntryApi(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message
      );
    }
  }
);
export const updateLeaveApproval = createAsyncThunk(
  "Approval/leave_approval",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const response = await updateLeaveApprovalApi(id, payload)
      showApiSuccessToast(response.data.message)
      return response.data;
    }
    catch (error) {
      return rejectWithValue(
        error.response?.data || { message: error.message }
      )
    }
  }
)

export const getManualEntryList = createAsyncThunk(
  "ManualEntry/List",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getManualEntryApi(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateManualApproval = createAsyncThunk(
  "Approval/manual_approval",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const response = await updateManualApprovalApi(id, payload)
      showApiSuccessToast(response.data.message)
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || {message: error.message})
    }
  }
)